<template>
  <div class="category-tutorial">
    <div class="group__title flex items-center">
      <h2 class="title flex-1">{{ category.title }}</h2>
      <nuxt-link
        type="text"
        class="more-btn flex justify-center items-center cursor-pointer"
        aria-label="go academy detail"
        :to="{ name: PageKey.TUTORIAL }"
      >
        {{ $t('cha-kan-geng-duo') }}
        <iconpark-icon name="arrowright" size="16"></iconpark-icon>
      </nuxt-link>
    </div>
    <div class="group__content">
      <ContentClassCard
        v-for="card in displayList"
        :key="card.id"
        :url="card.cover_url"
        :isNew="card.is_new"
        :link="{
          name: PageKey.TUTORIAL_INFO,
          params: {
            id: card?.guide_video_info
              ? card.guide_video_info?.[0].id
              : card?.id,
          },
        }"
        :video="
          card?.guide_video_info
            ? card.guide_video_info?.[0].video_url
            : card?.video_url
        "
        class="cursor-pointer"
        @click="handleCardClick(card)"
      >
      </ContentClassCard>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { type IHelpCategory } from '~/api/module/help-center'
import { reqGuidVideos, getClassSeries } from '~/api/module/class'
import { PageKey } from '~/constants/page'
import type { IGuidVideo, ISeriesClass } from '~/api/interface/class'

const props = defineProps<{
  category: IHelpCategory
  isAcademy: boolean
}>()
const router = useRouter()
const { data: seriesList } = useAsyncData(async () => {
  const res = await getClassSeries({ page: 1, page_size: 4 })
  return res.data?.results
})

const { data: lessonList } = useAsyncData(async () => {
  const res = await reqGuidVideos({ page: 1, page_size: 4 })
  return res.data?.results
})

const displayList = computed(() => {
  return [...(seriesList.value || []), ...(lessonList.value || [])].slice(0, 4)
})

const handleCardClick = (source: ISeriesClass | IGuidVideo) => {
  const query = props.isAcademy
    ? {
        nav: PageKey.ACADEMY,
      }
    : {}
  if (source.guide_video_info) {
    navigateTo({
      name: PageKey.TUTORIAL_INFO,
      params: { id: source.guide_video_info[0].id },
      query,
    })
  } else {
    navigateTo({
      name: PageKey.TUTORIAL_INFO,
      params: { id: source.id },
      query,
    })
  }
}
</script>

<style lang="scss" scoped>
.group {
  &__title {
    h2 {
      font-size: 18px;
      line-height: 1.4;
      color: var(--text-1);
    }
    .more-btn {
      font-size: 14px;
      line-height: 1;
      color: var(--text-1);
      opacity: 0.6;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  &__content {
    display: grid;
    grid-template-columns: repeat(4, minmax(56px, 1fr));
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: 162px;
    grid-auto-flow: dense;
    gap: 16px;
  }
}
</style>
